$(function () {
    var blockClass = 'home-slider';
    var dot = '.';

    var carouselClass = blockClass + '__carousel';
    var prevClass = blockClass + '__previous';
    var nextClass = blockClass + '__next';

    $(dot + carouselClass).each(function (carouselIndex, carouselElement) {
        var parent = $(carouselElement).parent();
        var prev = parent.find(dot + prevClass);
        var next = parent.find(dot + nextClass);

        var options = {
            container: carouselElement,
            nav: true,
            navContainer: ".home-slider__buttons",
            controls: true,
            controlsContainer: ".home-slider__control",
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            autoplayTimeout: 8000,
            speed: 400,
            edgePadding: 20
        };

        if (prev.length !== 0) {
            options.prevButton = prev.get(0);
        }

        if (next.length !== 0) {
            options.nextButton = next.get(0);
        }

        var slider = tns(options);
    });


});

/////////////////////////////////////////////////////////////

$(function () {
    var blockClass = 'logo-slider';
    var dot = '.';

    var carouselClass = blockClass + '__carousel';
    var prevClass = blockClass + '__previous';
    var nextClass = blockClass + '__next';

    $(dot + carouselClass).each(function (carouselIndex, carouselElement) {
        var parent = $(carouselElement).parent();
        var prev = parent.find(dot + prevClass);
        var next = parent.find(dot + nextClass);

        var optionsLogo = {
            container: carouselElement,
            loop: false,
            items: 2,
            slideBy: '1',
            nav: false,
            // navContainer: ".logo-slider__buttons",
            autoplay: false,
            speed: 400,
            autoplayButtonOutput: false,
            mouseDrag: true,
            controls: true,
            controlsContainer: ".logo-slider__control",
            responsive: {
                640: {
                    items: 6,
                },
                800: {
                    items: 6,
                }
            }
        };

        if (prev.length !== 0) {
            optionsLogo.prevButton = prev.get(0);
        }

        if (next.length !== 0) {
            optionsLogo.nextButton = next.get(0);
        }

        var slider = tns(optionsLogo);

        $(".logo-slider.--no-js").removeClass("--no-js");
        $(".logo-slider__control.--no-js").removeClass("--no-js");
        $(".logo-slider__slide.--no-js").removeClass("--no-js");
        $(".logo-slider__carousel.--no-js").removeClass("--no-js");

    });
});

////////////////////////////////////////////////////

// $(function () {

//     var blockClass = 'flex-slider';
//     var dot = '.';
//     $('flex-slider --no-js').removeClass('.--no-js');

//     var carouselClass = blockClass + '__carousel';
//     var prevClass = blockClass + '__previous';
//     var nextClass = blockClass + '__next';

//     $(dot + carouselClass).each(function (carouselIndex, carouselElement) {
//         var parent = $(carouselElement).parent();
//         var prev = parent.find(dot + prevClass);
//         var next = parent.find(dot + nextClass);

//         var options = {
//             container: carouselElement,
//             nav: true,
//             navContainer: ".flex-slider__buttons",
//             navPosition: "bottom",
//             controls: true,
//             controlsContainer: ".flex-slider__control",
//             autoplay: true,
//             autoplayButtonOutput: false,
//             autoplayHoverPause: true,
//             autoplayTimeout: 8000,
//             speed: 400,
//         };

//         if (prev.length !== 0) {
//             options.prevButton = prev.get(0);
//         }

//         if (next.length !== 0) {
//             options.nextButton = next.get(0);
//         }

//         var slider = tns(options);
//     });


// });

$(function () {

    var forEach = function (array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
        }
    };

    var sliders = document.querySelectorAll('.flex-slider');

    forEach(sliders, function (index, value) {
        let modifier = value.dataset.name;
        // console.log(modifier);

        var blockClass = 'flex-slider';
        // console.log(blockClass);
        var dot = '.';

        var carouselClass = blockClass + '__carousel-' + modifier;
        var prevClass = blockClass + '__previous-' + modifier;
        var nextClass = blockClass + '__next-' + modifier;
        var container = '.flex-slider__buttons-' + modifier;
        var control = '.flex-slider__control-' + modifier;
            // console.log(container);
            // console.log(control);
            // console.log(carouselClass);
        $(dot + carouselClass).each(function (carouselIndex, carouselElement) {
            var parent = $(carouselElement).parent();
            var prev = parent.find(dot + prevClass);
            // console.log('Prev' + prev);
            var next = parent.find(dot + nextClass);

            var options = {
                container: carouselElement,
                nav: true,
                navContainer: container,
                navPosition: "bottom",
                controls: true,
                controlsContainer: control,
                //controlsPosition: "top";
                autoplay: true,
                autoplayButtonOutput: false,
                autoplayHoverPause: true,
                autoplayTimeout: 8000,
                speed: 400,
                mouseDrag: true

            };

            if (prev.length !== 0) {
                options.prevButton = prev.get(0);
            }

            if (next.length !== 0) {
                options.nextButton = next.get(0);
            }


            // console.log(options);
            var slider = tns(options);

            $(".flex-slider.--no-js").removeClass("--no-js");
            $(".flex-slider__slide.--no-js").removeClass("--no-js");
            $(".flex-slider__control.--no-js").removeClass("--no-js");
            $(".flex-slider__buttons.--no-js").removeClass("--no-js");

        });


    });


});
